import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectCreateFileTemplateStatus = createSelector(
  [(store: RootState) => store.templateCreate.createFileTemplateStatus],
  (status) => status
);
